import { jsxs as b, jsx as a } from "react/jsx-runtime";
import { clsx as F } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { remCalc as M } from "../../style/base/index.js";
import { useFloatingTooltip as O } from "../../utils/use-floating-tooltip.js";
import { RocheUIIcon as S } from "../icon/roche-icon.js";
import { RocheUITooltipContent as D } from "../tooltip-content/roche-tooltip-content.js";
import e from "./roche-social-media.module.scss.js";
import { RocheUISocialMediaAlignment as l } from "./roche-social-media.type.js";
const H = 24, Q = ({
  overline: r,
  align: s = l.DEFAULT,
  disableFacebook: k = !1,
  disableTwitter: w = !1,
  disableLinkedin: y = !1,
  mailToSubject: R,
  url: i,
  facebookLabel: _,
  twitterLabel: g,
  linkedinLabel: N,
  copylinkLabel: C,
  copySuccessLabel: n,
  onClick: c
}) => {
  const { refs: d, floatingStyles: I, context: T, arrowRef: x, open: $, setOpen: m } = O({ placement: "bottom" }), E = [
    {
      "data-social": "email",
      icon: "mobile",
      href: `mailto:?subject=${R}&body=${i}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "facebook",
      icon: "facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${i}`,
      type: "link",
      shouldRender: !k,
      ariaLabel: _
    },
    {
      "data-social": "twitter",
      icon: "twitter",
      href: `http://twitter.com/intent/tweet?url=${i}`,
      type: "link",
      shouldRender: !w,
      ariaLabel: g
    },
    {
      "data-social": "linkedin",
      icon: "linkedin",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${i}`,
      type: "link",
      shouldRender: !y,
      ariaLabel: N
    },
    {
      "data-social": "xing",
      icon: "mobile",
      href: `https://www.xing.com/spi/shares/new?url=${i}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "copy",
      icon: "copy-link",
      href: "#",
      type: "button",
      shouldRender: !0,
      ariaLabel: C
    }
  ], p = async (t) => {
    const o = t.currentTarget.getAttribute("data-social");
    o === "copy" && (t.preventDefault(), await navigator.clipboard.writeText(i), m(!0), setTimeout(() => m(!1), 2200)), o && c && c(t, o);
  }, L = F(
    e["social-media"],
    s === l.LEFT && e["social-media--align-left"],
    s === l.CENTER && e["social-media--align-center"],
    s === l.RIGHT && e["social-media--align-right"]
  );
  return /* @__PURE__ */ b("div", { className: L, children: [
    r && /* @__PURE__ */ a("p", { className: e["social-media__overline"], children: r }),
    /* @__PURE__ */ a("ul", { className: e["social-media__links-list"], children: E.map((t, o) => {
      const { shouldRender: U, icon: A, ariaLabel: h, type: j, ...v } = t;
      if (!U)
        return null;
      const f = t["data-social"], u = f === "copy";
      return (
        // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
        /* @__PURE__ */ b("li", { className: e["social-media__link-wrapper"], children: [
          /* @__PURE__ */ a("span", { className: e["social-media__icon"], children: /* @__PURE__ */ a(S, { icon: A, height: `${M(H)}rem`, decorative: !0 }) }),
          j === "button" ? /* @__PURE__ */ a(
            "button",
            {
              className: e["social-media__link"],
              ref: u ? d.setReference : void 0,
              onClick: p,
              "aria-label": h,
              "data-social": f,
              type: "button"
            }
          ) : (
            // biome-ignore lint/a11y/useAriaPropsSupportedByRole: aria-label is supported by <a> elements!
            // biome-ignore lint/a11y/noStaticElementInteractions: we need a click handler on the <a> element to track click
            /* @__PURE__ */ a(
              "a",
              {
                className: e["social-media__link"],
                target: "_blank",
                rel: "noreferrer",
                onClick: p,
                "aria-label": h,
                ...v
              }
            )
          ),
          u && n && /* @__PURE__ */ a(
            D,
            {
              floatingStyles: I,
              arrowRef: x,
              open: $,
              context: T,
              refs: d,
              children: n
            }
          )
        ] }, o)
      );
    }) })
  ] });
};
export {
  Q as RocheUISocialMedia
};
